// extracted by mini-css-extract-plugin
export default {"resumeSectionTitle":"ResumeSectionTitle_resumeSectionTitle__e7bZ0","greenLine":"ResumeSectionTitle_greenLine__2xmts"};